
import { supabase } from '@/lib/supabase';
import { toast } from 'sonner';

/**
 * Validates that the current user session is still active
 */
export const validateSession = async (): Promise<boolean> => {
  try {
    const { data: { user }, error } = await supabase.auth.getUser();
    
    if (error || !user) {
      console.error('Session validation failed:', error);
      return false;
    }
    
    return true;
  } catch (error) {
    console.error('Session validation error:', error);
    return false;
  }
};

/**
 * Enhanced authentication guard with session validation
 */
export const requireAuth = async (): Promise<string | null> => {
  const isValidSession = await validateSession();
  
  if (!isValidSession) {
    toast.error('Please sign in to continue');
    return null;
  }
  
  const { data: { user } } = await supabase.auth.getUser();
  return user?.id || null;
};

/**
 * Validates admin permissions
 */
export const validateAdminAccess = async (): Promise<boolean> => {
  const userId = await requireAuth();
  if (!userId) return false;
  
  try {
    const { data, error } = await supabase
      .from('user_roles')
      .select('role')
      .eq('user_id', userId)
      .eq('role', 'admin')
      .maybeSingle();
      
    if (error) {
      console.error('Admin validation error:', error);
      return false;
    }
    
    return !!data;
  } catch (error) {
    console.error('Admin validation error:', error);
    return false;
  }
};
